const hideConfigs = {
  '/cart': 'hideConfigCart',
  '/account/register': 'hideConfigAuth',
  '/account/login': 'hideConfigAuth',
}

let hideConfig

try {
  hideConfig = JSON.parse(sessionStorage.getItem(hideConfigs[window.location.pathname]))
} catch {
  hideConfig = null
}

if (!hideConfig) {
  Object.values(hideConfigs).forEach((key) => {
    sessionStorage.removeItem(key)
  })
} else {
  let hideCss = ''

  if (hideConfig.announcement) {
    hideCss += `.utility-bar { display: none !important; }`
  }

  if (hideConfig.headerHomeLink) {
    hideCss += ` .header__heading-link { pointer-events: none !important; }`
  }

  if (hideConfig.headerMenu) {
    hideCss += ` .header__inline-menu { display: none !important; } header-drawer { display: none !important; }`
  }

  if (hideConfig.headerIcons) {
    hideCss += ` .header__icons { display: none !important; }`
  }

  if (hideConfig.footer) {
    hideCss += ` .footer { display: none !important; }`
  }

  if (hideCss) {
    const style = document.createElement('style');
    style.textContent = hideCss;
    document.head.appendChild(style);
  }
}
